import gql from 'graphql-tag';

const GET_PRICING_LIST = `
  query pricingList {
    pricingLists {
      id
      planName
      features
      monthlyPrice
      monthlyPriceDescription
      annualPrice
      annualPriceDescription
      endPoints
      endPointsDescription
      endPointsPackMonthlyPrice
      endPointsPackAnnualPrice
      isEndpointsAvailable
      ctaSlug
      planOrder
      isPopular
      featureLists {
        id
        name
        parentName
        parentSlug
        features
        featuresSlug
        featuresDescription
      }
    }
  }
`;

const GET_PURCHASE_PRODUCT_FEATURE_META = gql`
  query getPurchaseProductFeatureMeta {
    getPurchaseProductFeatureMeta
  }
`;

const GET_SUBCRIPTION_INVOICES = gql`
  query($pageSize: Int, $offset: String) {
    getSubscriptionInvoices(pageSize: $pageSize, offset: $offset) {
      invoices {
        id
        total
        status #SubscriptionInvoiceStatus
        date
        licenseQuantity
        addonQuantity
        hasOverageDevice
      }
      offset
    }
  }
`;

// enum SubscriptionInvoiceStatus {
//   PAID,
//   POSTED,
//   PAYMENT_DUE,
//   NOT_PAID,
//   VOIDED,
//   PENDING,
// }

const GET_CUSTOMER_CARD_DETAILS = gql`
  query {
    getCustomerCardDetails {
      status #CardStatus
      last4
      cardType #CardType
      fundingType #FundingType
      expiryMonth
      expiryYear
    }
  }
`;

// enum CardStatus {
//   VALID,
//   EXPIRING,
//   EXPIRED,
// }

// enum CardType {
//   VISA,
//   MASTERCARD,
//   AMERICAN_EXPRESS,
//   DISCOVER,
//   JCB,
//   DINERS_CLUB,
//   OTHER,
//   NOT_APPLICABLE,
// }

// enum FundingType {
//   CREDIT,
//   DEBIT,
//   PREPAID,
//   NOT_KNOWN,
//   NOT_APPLICABLE,
// }

const GET_ALL_PLANS = gql`
  query {
    getAllPlans {
      planId
      planName
      chargeBeePlanId
      planOrder
    }
  }
`;

const GET_ALL_ACTIVE_PLANS = gql`
  query {
    getAllActivePlans {
      planId
      planName
      chargeBeePlanId
      planOrder
      planPrices {
        id
        currency {
          id
          currencyCode
        }
        durationValue
        duration #PaymentDuration
        priceValue
        pricingModel
        price
        chargeBeePlanPriceId
      }
      planFeatures {
        id
        featureName
        module #FeatureModule
      }
      endPointsCount
      features
    }
  }
`;

const GET_PLANS = gql`
  query {
    getAllPlans {
      planId
      planName
      chargeBeePlanId
      planOrder
      planPrices {
        id
        currency {
          id
          currencyCode
        }
        durationValue
        duration #PaymentDuration
        priceValue
        pricingModel
        price
        chargeBeePlanPriceId
      }
      purchaseFeatures {
        planProductFeatureId
        feature {
          featureId
          name
          labelKey
          releaseState
        }
        available
        availableWithAddOn
        enabled
        upsell
        upsellPlanId
        upsellAddonId
      }
      endPointsCount
    }
  }
`;

const GET_ALL_FEATURES = gql`
  query {
    getPlanFeatures
  }
`;

const GET_PRODUCT_FEATURES = gql`
  query($input: GetProductFeaturesCategoriesInput!) {
    getProductFeaturesCategories(input: $input) {
      categoryId
      labelKey
      features {
        featureId
        name
        labelKey
        releaseState
      }
      subcategories {
        categoryId
        labelKey
        features {
          featureId
          name
          labelKey
          releaseState
        }
        subcategories {
          categoryId
          labelKey
          features {
            featureId
            name
            labelKey
            releaseState
          }
          releaseState
        }
        releaseState
      }
      releaseState
    }
  }
`;

// enum PaymentDuration {
//   MONTHLY,
//   YEARLY
// }

// enum FeatureModule {
//   PSA,
//   RMM
// }

const GET_CUSTOMER_SUBSCRIPTION = gql`
  query {
    getCustomerSubscription {
      subscriptionId
      autoCollection
      overageBillingPeriod {
        startDateTime
        endDateTime
      }
      customer {
        customerId
        signupEmailId
        source {
          name
        }
      }
      subscriptionStatus #SubscriptionStatus
      trialEndDateTime
      lastStatusUpdateTime
      licenseCount

      subscribedAddons {
        id
        addon {
          addonId
          name
          chargeBeeAddonId
        }
        addonLicenseCount
      }
      resourceVersion
      nextBillingDateTime
      billingPeriod #BillingPeriod
      currentPlanPrice {
        id
        plan {
          planId
          planName
          chargeBeePlanId
          planOrder
          planPrices {
            id
            currency {
              id
              currencyCode
            }
            durationValue
            duration #PaymentDuration
            priceValue
            pricingModel
            price
            chargeBeePlanPriceId
          }
          endPointsCount
        }
        currency {
          id
          currencyCode
        }
        durationValue
        duration #PaymentDuration
        priceValue
        pricingModel
        price
        chargeBeePlanPriceId
      }
    }
  }
`;

// enum SubscriptionStatus {
//     ACTIVE,
//     TRIAL,
//     TRIAL_EXPIRED,
//     NON_RENEWING,
//     PAUSED,
//     CANCELLED
// }

// enum BillingPeriod {
//   MONTH,
//   YEAR
// }

const CREATE_PURCHASE_SUBSCRIPTION_CONFIGURATION = gql`
  mutation($input: HostedPageInput) {
    createPurchaseSubscriptionConfiguration(hostedPageInput: $input) {
      id
      type
      url
      state
      embed
      createdAt
      expiresAt
    }
  }
`;

const UPGRADE_SUBSCRIPTION = gql`
  mutation($input: HostedPageInput) {
    upgradeSubscription(hostedPageInput: $input) {
      id
      type
      url
      state
      embed
      createdAt
      expiresAt
    }
  }
`;

const UPDATE_CUSTOMER_ON_POST_SIGNUP = gql`
  mutation($input: UpdateCustomerOnPostSignupInput!) {
    updateCustomerOnPostSignup(input: $input)
  }
`;

const ADD_UPDATE_CARD_DETAILS = gql`
  mutation add {
    addOrUpdatePaymentSource {
      id
      type
      url
      state
    }
  }
`;

const CONFIRM_CARD_DETAILS = gql`
  mutation($status: OperationStatus) {
    paymentSourceCallBack(status: $status)
  }
`;
const CONFIRM_PAYMENT = gql`
  mutation($input: HostedPageInput) {
    confirmPayment(hostedPageInput: $input)
  }
`;

const UPGRADE_SUBSCRIPTION_STATUS = gql`
  mutation($input: UpdatePurchaseSubscriptionStatusInput) {
    updateSubscriptionPurchaseStatus(input: $input)
  }
`;

const DOWNGRADE_SUBSCRIPTION = gql`
  mutation($chargeBeePlanPriceId: String) {
    downgradeSubscription(chargeBeePlanPriceId: $chargeBeePlanPriceId)
  }
`;

const CANCEL_SUBSCRIPTION = gql`
  mutation {
    cancelSubscription
  }
`;

const UPDATE_ASSET_LICENSE_STATE = gql`
  mutation($assetIds: [ID!], $operationalStatus: AssetOperationalStatus) {
    updateAssetLicenseState(
      assetIds: $assetIds
      operationalStatus: $operationalStatus
    )
  }
`;

const GET_CUSTOMER_PAYMENT_STATUS = gql`
  query {
    getCustomerDetail {
      customerId
      checkoutProgressState
    }
  }
`;

const GET_INVOICE_DOWNLOAD_LINK = gql`
  query($invoiceId: String) {
    getInvoiceDownloadLink(invoiceId: $invoiceId)
  }
`;

const GET_ESTIMATE = gql`
  query($hostedPageInputDTO: HostedPageInput) {
    getEstimate(hostedPageInputDTO: $hostedPageInputDTO) {
      subTotal
      total
      taxDetails {
        taxName
        taxAmount
      }
      plan {
        planId
        planName
        chargeBeePlanId
        planOrder
      }
      licenseQuantity
      licenseUnitPrice
      licenseTotalAmount
      addonEstimates {
        addon {
          addonId
          name
          chargeBeeAddonId
        }
        licenseQuantity
        licenseUnitPrice
        licenseTotalAmount
      }
    }
  }
`;

const GET_ALL_PAYMENT_CURRENCIES = gql`
  query {
    getAllPaymentCurrencies {
      id
      currencyCode
    }
  }
`;

const GET_ALL_ACTIVE_ADDONS = gql`
  query {
    getAllActiveAddons {
      addonId
      name
      chargeBeeAddonId
      addonPrices {
        id
        currency {
          id
          currencyCode
        }
        duration #PaymentDuration
        durationValue
        priceValue
        pricingModel
        price
        chargeBeeAddonPriceId
      }
      offeringEntityType
      countPerLicense
    }
  }
`;

const GET_ESTIMATE_FOR_LINEITEM = gql`
  query($input: IdentifierInput) {
    getProductSubscriptionEstimateForExistingLineItems(input: $input) {
      termInvoiceEstimate {
        plan {
          planPrice {
            id
            chargeBeePlanPriceId
          }
          minimumQuantity
          quantity
          unitPrice
          amount
        }
        addons {
          addon {
            offeringEntityType
            countPerLicense
          }
          addonPrice {
            id
            chargeBeeAddonPriceId
          }
          minimumQuantity
          quantity
          unitPrice
          amount
          active
        }
        subTotal
        taxes {
          taxName
          taxAmount
        }
        total
      }
      currentInvoiceEstimate {
        subTotal
        total
        roundOff
        creditsApplied
        amountDue
        taxes {
          taxName
          taxAmount
        }
        lineItemGroups {
          dateFrom
          dateTo
          isProrated
          plan {
            planPrice {
              id
              chargeBeePlanPriceId
            }
            minimumQuantity
            quantity
            unitPrice
            amount
            tieredBreakdown
          }
          addons {
            addon {
              addonId
              name
            }
            addonPrice {
              id
              chargeBeeAddonPriceId
            }
            minimumQuantity
            quantity
            unitPrice
            amount
            active
            tieredBreakdown
          }
        }
      }
      overageInvoiceEstimate {
        subTotal
        total
        roundOff
        creditsApplied
        amountDue
        taxes {
          taxName
          taxAmount
        }
        lineItemGroups {
          dateFrom
          dateTo
          isProrated
          charge {
            chargePrice {
              chargePriceId
              charge {
                chargeId
              }
              currency {
                id
                currencyCode
              }
            }
            quantity
            unitPrice
            amount
          }
        }
      }
      nextInvoiceEstimate {
        subTotal
        total
        roundOff
        creditsApplied
        amountDue
        taxes {
          taxName
          taxAmount
        }
        lineItemGroups {
          dateFrom
          dateTo
          isProrated
          charge {
            chargePrice {
              chargePriceId
              charge {
                chargeId
              }
              currency {
                id
                currencyCode
              }
            }
            quantity
            unitPrice
            amount
          }
          plan {
            planPrice {
              id
              chargeBeePlanPriceId
            }
            minimumQuantity
            quantity
            unitPrice
            amount
            tieredBreakdown
          }
          addons {
            addon {
              addonId
              name
            }
            addonPrice {
              id
              chargeBeeAddonPriceId
            }
            minimumQuantity
            quantity
            unitPrice
            amount
            active
            tieredBreakdown
          }
        }
      }
      offeringEntities {
        offeringEntityType
        available
        purchased
        overageAllowed
        billableOverage
      }
    }
  }
`;

const GET_ESTIMATE_FOR_LINEITEM_UPGRADE = gql`
  query($input: IdentifierInput) {
    getProductSubscriptionEstimateForExistingLineItems(input: $input) {
      termInvoiceEstimate {
        plan {
          planPrice {
            id
            chargeBeePlanPriceId
          }
          minimumQuantity
          quantity
          unitPrice
          amount
        }
        addons {
          addon {
            offeringEntityType
            countPerLicense
          }
          addonPrice {
            id
            chargeBeeAddonPriceId
          }
          minimumQuantity
          quantity
          unitPrice
          amount
          active
        }
        subTotal
        taxes {
          taxName
          taxAmount
        }
        total
      }
      immediateInvoiceEstimate {
        plan {
          planPrice {
            id
            chargeBeePlanPriceId
          }
          minimumQuantity
          quantity
          unitPrice
          amount
        }
        addons {
          addon {
            offeringEntityType
            countPerLicense
          }
          addonPrice {
            id
            chargeBeeAddonPriceId
          }
          minimumQuantity
          quantity
          unitPrice
          amount
          active
        }
        subTotal
        taxes {
          taxName
          taxAmount
        }
        total
        creditsApplied
        amountDue
      }
      offeringEntities {
        offeringEntityType
        available
        purchased
      }
      restrictedOfferingEntities
    }
  }
`;

const GET_ESTIMATE_FOR_ALL_LINEITEMS = gql`
  query($input: GetProductSubscriptionEstimateForLineItemsInput!) {
    getProductSubscriptionEstimateForLineItems(input: $input) {
      termInvoiceEstimate {
        plan {
          planPrice {
            id
            chargeBeePlanPriceId
          }
          minimumQuantity
          quantity
          unitPrice
          amount
        }
        addons {
          addon {
            offeringEntityType
            countPerLicense
          }
          addonPrice {
            id
            chargeBeeAddonPriceId
          }
          minimumQuantity
          quantity
          unitPrice
          amount
          active
        }
        subTotal
        taxes {
          taxName
          taxAmount
        }
        total
      }
      immediateInvoiceEstimate {
        plan {
          planPrice {
            id
            chargeBeePlanPriceId
          }
          minimumQuantity
          quantity
          unitPrice
          amount
        }
        addons {
          addon {
            offeringEntityType
            countPerLicense
          }
          addonPrice {
            id
            chargeBeeAddonPriceId
          }
          minimumQuantity
          quantity
          unitPrice
          amount
          active
        }
        subTotal
        taxes {
          taxName
          taxAmount
        }
        total
        creditsApplied
        amountDue
      }
      currentInvoiceEstimate {
        subTotal
        total
        roundOff
        creditsApplied
        amountDue
        taxes {
          taxName
          taxAmount
        }
        lineItemGroups {
          dateFrom
          dateTo
          isProrated
          plan {
            planPrice {
              id
              chargeBeePlanPriceId
            }
            minimumQuantity
            quantity
            unitPrice
            amount
            tieredBreakdown
          }
          addons {
            addon {
              addonId
              name
            }
            addonPrice {
              id
              chargeBeeAddonPriceId
            }
            minimumQuantity
            quantity
            unitPrice
            amount
            active
            tieredBreakdown
          }
        }
      }
      overageInvoiceEstimate {
        subTotal
        total
        roundOff
        creditsApplied
        amountDue
        taxes {
          taxName
          taxAmount
        }
        lineItemGroups {
          dateFrom
          dateTo
          isProrated
          charge {
            chargePrice {
              chargePriceId
              charge {
                chargeId
              }
              currency {
                id
                currencyCode
              }
            }
            quantity
            unitPrice
            amount
          }
        }
      }
      nextInvoiceEstimate {
        subTotal
        total
        roundOff
        creditsApplied
        amountDue
        taxes {
          taxName
          taxAmount
        }
        lineItemGroups {
          dateFrom
          dateTo
          isProrated
          charge {
            chargePrice {
              chargePriceId
              charge {
                chargeId
              }
              currency {
                id
                currencyCode
              }
            }
            quantity
            unitPrice
            amount
          }
          plan {
            planPrice {
              id
              chargeBeePlanPriceId
            }
            minimumQuantity
            quantity
            unitPrice
            amount
            tieredBreakdown
          }
          addons {
            addon {
              addonId
              name
            }
            addonPrice {
              id
              chargeBeeAddonPriceId
            }
            minimumQuantity
            quantity
            unitPrice
            amount
            active
            tieredBreakdown
          }
        }
      }
      offeringEntities {
        offeringEntityType
        available
        purchased
        overageAllowed
        billableOverage
      }
      restrictedOfferingEntities
    }
  }
`;

const GET_PRODUCT_OFFERING_ENTITIES = gql`
  query {
    getProductOfferingEntities {
      offeringEntityType
      available
      purchased
      overageAllowed
      billableOverage
    }
  }
`;

const GET_OVERAGE_DEVICES_LIST = gql`
  query(
    $entityId: ID
    $billableItems: Boolean
    $listInfoInput: ListInfoInput!
  ) {
    getOverageItems(
      entityId: $entityId
      billableItems: $billableItems
      listInfoInput: $listInfoInput
    ) {
      overageItems {
        itemId
        itemName
        startDateTime
        endDateTime
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const ACTIVATE_TRIAL_ADDON = gql`
  mutation activateTrialAddon($addonId: String!) {
    activateTrialAddon(addonId: $addonId)
  }
`;

export {
  GET_PRICING_LIST,
  CREATE_PURCHASE_SUBSCRIPTION_CONFIGURATION,
  UPGRADE_SUBSCRIPTION,
  UPDATE_CUSTOMER_ON_POST_SIGNUP,
  CONFIRM_PAYMENT,
  DOWNGRADE_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION,
  GET_CUSTOMER_SUBSCRIPTION,
  GET_ALL_PLANS,
  GET_PLANS,
  GET_ALL_ACTIVE_PLANS,
  GET_ALL_FEATURES,
  GET_CUSTOMER_CARD_DETAILS,
  GET_SUBCRIPTION_INVOICES,
  GET_INVOICE_DOWNLOAD_LINK,
  GET_ESTIMATE,
  GET_ALL_PAYMENT_CURRENCIES,
  GET_ALL_ACTIVE_ADDONS,
  GET_PRODUCT_FEATURES,
  GET_ESTIMATE_FOR_LINEITEM,
  GET_ESTIMATE_FOR_LINEITEM_UPGRADE,
  GET_ESTIMATE_FOR_ALL_LINEITEMS,
  GET_PRODUCT_OFFERING_ENTITIES,
  UPGRADE_SUBSCRIPTION_STATUS,
  GET_CUSTOMER_PAYMENT_STATUS,
  ADD_UPDATE_CARD_DETAILS,
  UPDATE_ASSET_LICENSE_STATE,
  CONFIRM_CARD_DETAILS,
  GET_PURCHASE_PRODUCT_FEATURE_META,
  GET_OVERAGE_DEVICES_LIST,
  ACTIVATE_TRIAL_ADDON
};
